import { render, staticRenderFns } from "./Model13.vue?vue&type=template&id=27c923f5&scoped=true"
import script from "./Model13.vue?vue&type=script&lang=js"
export * from "./Model13.vue?vue&type=script&lang=js"
import style0 from "./Model13.vue?vue&type=style&index=0&id=27c923f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c923f5",
  null
  
)

export default component.exports